.role-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: bold;
  color: #fff;
  background-color: var(--bs-primary);
  padding: 0.2rem 0.45rem !important;
  margin: 0.1rem;
  border: 0 !important;
  border-radius: 0.3rem;
}
